class BeeThemeScripts
{
   constructor(settings)
   {
      this.settings = settings;
      this.init();
   }

   init = () =>
   {
      console.log('settings', this.settings);
      this.initializeTns();
      this.handleCartSubmit();
   }

   initializeTns = () =>
   {
      const tns_slideshow = document.querySelectorAll('[data-tns]');
      if (tns_slideshow.length)
      {
         [...tns_slideshow].map(slideshow =>
         {
            let options = {
               container: slideshow
            }
            let custom = typeof slideshow.dataset.tns !== 'undefined' && JSON.parse(slideshow.dataset.tns);
            let carousel = tns(Object.assign(options, custom));
         });
      }
   }

   handleCartSubmit = () =>
   {
      const cartForm = document.getElementById('cartform');
      const cartFormBtn = document.querySelector('checkout-button');
      const bundleTag = this.settings?.bundle_tag;
      const bundleMinQty = this.settings?.bundle_min_qty;
      const bundleAlert = this.settings?.bundle_alert;

      if (cartForm && bundleTag)
      {
         cartForm.addEventListener('submit', async (event) =>
         {
            event.preventDefault();
            try
            {
               const cartData = await fetch('/cart.js').then(response => response.json());
               if( cartData )
               {
                  const bundleItems = cartData.items.filter(item => item.properties?.bundle_tag === bundleTag);
                  if( bundleItems.length > 0 )
                  {
                     const totalQty = bundleItems.reduce((acc, item) => acc + item.quantity, 0);
                     if( totalQty % bundleMinQty !== 0 )
                     {
                        alert(bundleAlert);
                        return false;
                     }
                  }
               }
               cartForm.action = '/checkout';
               cartForm.submit();
            } catch (error)
            {
               console.log(error.message);
            }
            
         });
      }
   }
}